import React from "react";
import styles from "./Education.module.css";

function Education(props: any) {
  return (
    <div className={styles.Education}>
      <p>
        <span className={styles.degreeType}>Bachelors of Science</span>,{" "}
        <span>Computer Engineering (Minor: Computer Science)</span>
      </p>

      <p>
        Villanova University — Villanova, PA |{" "}
        <span className={styles.honors}>Cum Laude</span>
      </p>
    </div>
  );
}

export default Education;
